import { useState, useEffect } from "react";
import { Link as RouterLink, useParams, useNavigate } from "react-router-dom";
import { Avatar, Box, Button, ButtonGroup, Container, Grid, Stack, Typography, TextField, Chip, Checkbox, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Select, OutlinedInput, MenuItem, useTheme, FormControl, FormControlLabel, FormLabel, RadioGroup, Radio, Paper, Autocomplete, Tabs, Tab } from "@mui/material";
// components
import Page from "src/components/Page";
import moment from "moment";
import { alert } from "src/services/alert";
import FormItem from "src/components/form-item/FormItem";
import { useSelector } from "react-redux";
import FormDialog from "src/components/common/FormDialog";
import NavBack from "src/components/common/NavBack";
import { asyncRequest } from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import { IMG_BASE_URL } from "src/config/constants";
import { Switch } from "@mui/material";
// ----------------------------------------------------------------------

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function AgreementList() {
  const navigate = useNavigate();

  const [agreementMap, setAgreementMap] = useState({});
  const [tab, setTab] = useState(0);
  const [items, setItems] = useState([]);
  // 支付优惠配置
  const [paymentDiscountConfig, setPaymentDiscountConfig] = useState({
    paymentDiscountEnabled: false,
    paymentDiscountMinAmount: "0.01",
    paymentDiscountMaxAmount: "5.00",
    paymentDiscountRatio: "0.01",
  });
  const [paymentDiscountItems, setPaymentDiscountItems] = useState([]);
  
  // 商家权益金限额配置
  const [merchantXfqLimitConfig, setMerchantXfqLimitConfig] = useState({
    offlineMerchantXfqLimitEnabled: false,
    offlineMerchantXfqDailyLimit: "10000.00",
  });
  
  // 用户权益金限额配置
  const [userXfqLimitConfig, setUserXfqLimitConfig] = useState({
    offlineUserXfqLimitEnabled: false,
    offlineUserXfqSingleLimit: "1000.00",
    offlineUserXfqDailyLimit: "5000.00",
  });
  
  // 权益金使用限时配置
  const [xfqTimeLimitConfig, setXfqTimeLimitConfig] = useState({
    offlineXfqTimeLimitEnabled: false,
    offlineXfqTimeLimitStart: "09:00",
    offlineXfqTimeLimitEnd: "21:00",
  });

  // console.log(agreementMap);

  useEffect(() => {
    getAgreementMap();
    loadPaymentDiscountConfig();
    loadMerchantXfqLimitConfig();
    loadUserXfqLimitConfig();
    loadXfqTimeLimitConfig();
  }, []);
  async function getAgreementMap() {
      let data =[
        {
          "id": 1,
          "key": "paymentDiscount",
          "name": "商城支付优惠",
        },
        {
          "id": 2,
          "key": "merchantXfqLimit",
          "name": "商家权益金限额",
        },
        {
          "id": 3,
          "key": "userXfqLimit",
          "name": "用户权益金限额",
        },
        {
          "id": 4,
          "key": "xfqTimeLimit",
          "name": "权益金使用限时",
        },
    ]
    setItems(data);
    console.log(data[tab])
  }
  
  // tab切换
  function handleTabChange(e, val) {
    console.log(e, val);
    setTab(val);
  }
  
  // 更新支付优惠配置项
  function handlePaymentDiscountChange(key, value) {
    setPaymentDiscountConfig(prev => ({
      ...prev,
      [key]: value,
    }));
  }

  // 加载支付优惠配置
  async function loadPaymentDiscountConfig() {
    try {
      // 使用 keys 参数精确查询4个配置项
      const { data } = await asyncRequest({
        method: "post",
        path: "/system/config/list",
        data: {
          page: 0,
          size: 10,
          keys: [
            'paymentDiscountEnabled',
            'paymentDiscountMinAmount',
            'paymentDiscountMaxAmount',
            'paymentDiscountRatio'
          ],
        },
      });

      if (data && data.length > 0) {
        const config = {};
        data.forEach(item => {
          config[item.key] = item.value;
        });

        setPaymentDiscountConfig({
          paymentDiscountEnabled: config.paymentDiscountEnabled === '1' || config.paymentDiscountEnabled === 1,
          paymentDiscountMinAmount: config.paymentDiscountMinAmount || "0.01",
          paymentDiscountMaxAmount: config.paymentDiscountMaxAmount || "5.00",
          paymentDiscountRatio: config.paymentDiscountRatio || "0.01",
        });
        setPaymentDiscountItems(data);
      }
    } catch (err) {
      console.error('加载支付优惠配置失败:', err);
    }
  }

  // 保存支付优惠配置
  async function handlePaymentDiscountSubmit() {
    try {
      // 调用专用的批量更新接口
      const { msg } = await asyncRequest({
        method: "post",
        path: "/system/config/payment-discount/update",
        data: {
          paymentDiscountEnabled: paymentDiscountConfig.paymentDiscountEnabled,
          paymentDiscountMinAmount: paymentDiscountConfig.paymentDiscountMinAmount,
          paymentDiscountMaxAmount: paymentDiscountConfig.paymentDiscountMaxAmount,
          paymentDiscountRatio: paymentDiscountConfig.paymentDiscountRatio,
        },
      });

      alert(msg || '支付优惠配置保存成功', 'success');
      loadPaymentDiscountConfig();
    } catch (err) {
      console.error('保存失败:', err);
      alert(err?.message || err || '保存失败');
    }
  }

  // ========== 商家权益金限额 ==========
  
  // 加载商家权益金限额配置
  async function loadMerchantXfqLimitConfig() {
    try {
      const { data } = await asyncRequest({
        method: "post",
        path: "/system/config/list",
        data: {
          page: 0,
          size: 10,
          keys: [
            'offlineMerchantXfqLimitEnabled',
            'offlineMerchantXfqDailyLimit',
          ],
        },
      });

      if (data && data.length > 0) {
        const config = {};
        data.forEach(item => {
          config[item.key] = item.value;
        });

        setMerchantXfqLimitConfig({
          offlineMerchantXfqLimitEnabled: config.offlineMerchantXfqLimitEnabled === '1' || config.offlineMerchantXfqLimitEnabled === 1,
          offlineMerchantXfqDailyLimit: config.offlineMerchantXfqDailyLimit || "10000.00",
        });
      }
    } catch (err) {
      console.error('加载商家权益金限额配置失败:', err);
    }
  }

  // 更新商家权益金限额配置
  function handleMerchantXfqLimitChange(key, value) {
    setMerchantXfqLimitConfig(prev => ({
      ...prev,
      [key]: value,
    }));
  }

  // 保存商家权益金限额配置
  async function handleMerchantXfqLimitSubmit() {
    try {
      const { msg } = await asyncRequest({
        method: "post",
        path: "/system/config/merchant-xfq-limit/update",
        data: {
          offlineMerchantXfqLimitEnabled: merchantXfqLimitConfig.offlineMerchantXfqLimitEnabled,
          offlineMerchantXfqDailyLimit: merchantXfqLimitConfig.offlineMerchantXfqDailyLimit,
        },
      });

      alert(msg || '商家权益金限额配置保存成功', 'success');
      loadMerchantXfqLimitConfig();
    } catch (err) {
      console.error('保存失败:', err);
      alert(err?.message || err || '保存失败');
    }
  }

  // ========== 用户权益金限额 ==========
  
  // 加载用户权益金限额配置
  async function loadUserXfqLimitConfig() {
    try {
      const { data } = await asyncRequest({
        method: "post",
        path: "/system/config/list",
        data: {
          page: 0,
          size: 10,
          keys: [
            'offlineUserXfqLimitEnabled',
            'offlineUserXfqSingleLimit',
            'offlineUserXfqDailyLimit',
          ],
        },
      });

      if (data && data.length > 0) {
        const config = {};
        data.forEach(item => {
          config[item.key] = item.value;
        });

        setUserXfqLimitConfig({
          offlineUserXfqLimitEnabled: config.offlineUserXfqLimitEnabled === '1' || config.offlineUserXfqLimitEnabled === 1,
          offlineUserXfqSingleLimit: config.offlineUserXfqSingleLimit || "1000.00",
          offlineUserXfqDailyLimit: config.offlineUserXfqDailyLimit || "5000.00",
        });
      }
    } catch (err) {
      console.error('加载用户权益金限额配置失败:', err);
    }
  }

  // 更新用户权益金限额配置
  function handleUserXfqLimitChange(key, value) {
    setUserXfqLimitConfig(prev => ({
      ...prev,
      [key]: value,
    }));
  }

  // 保存用户权益金限额配置
  async function handleUserXfqLimitSubmit() {
    try {
      const { msg } = await asyncRequest({
        method: "post",
        path: "/system/config/user-xfq-limit/update",
        data: {
          offlineUserXfqLimitEnabled: userXfqLimitConfig.offlineUserXfqLimitEnabled,
          offlineUserXfqSingleLimit: userXfqLimitConfig.offlineUserXfqSingleLimit,
          offlineUserXfqDailyLimit: userXfqLimitConfig.offlineUserXfqDailyLimit,
        },
      });

      alert(msg || '用户权益金限额配置保存成功', 'success');
      loadUserXfqLimitConfig();
    } catch (err) {
      console.error('保存失败:', err);
      alert(err?.message || err || '保存失败');
    }
  }

  // ========== 权益金使用限时 ==========
  
  // 加载权益金使用限时配置
  async function loadXfqTimeLimitConfig() {
    try {
      const { data } = await asyncRequest({
        method: "post",
        path: "/system/config/list",
        data: {
          page: 0,
          size: 10,
          keys: [
            'offlineXfqTimeLimitEnabled',
            'offlineXfqTimeLimitStart',
            'offlineXfqTimeLimitEnd',
          ],
        },
      });

      if (data && data.length > 0) {
        const config = {};
        data.forEach(item => {
          config[item.key] = item.value;
        });

        setXfqTimeLimitConfig({
          offlineXfqTimeLimitEnabled: config.offlineXfqTimeLimitEnabled === '1' || config.offlineXfqTimeLimitEnabled === 1,
          offlineXfqTimeLimitStart: config.offlineXfqTimeLimitStart || "09:00",
          offlineXfqTimeLimitEnd: config.offlineXfqTimeLimitEnd || "21:00",
        });
      }
    } catch (err) {
      console.error('加载权益金使用限时配置失败:', err);
    }
  }

  // 更新权益金使用限时配置
  function handleXfqTimeLimitChange(key, value) {
    setXfqTimeLimitConfig(prev => ({
      ...prev,
      [key]: value,
    }));
  }

  // 保存权益金使用限时配置
  async function handleXfqTimeLimitSubmit() {
    try {
      const { msg } = await asyncRequest({
        method: "post",
        path: "/system/config/xfq-time-limit/update",
        data: {
          offlineXfqTimeLimitEnabled: xfqTimeLimitConfig.offlineXfqTimeLimitEnabled,
          offlineXfqTimeLimitStart: xfqTimeLimitConfig.offlineXfqTimeLimitStart,
          offlineXfqTimeLimitEnd: xfqTimeLimitConfig.offlineXfqTimeLimitEnd,
        },
      });

      alert(msg || '权益金使用限时配置保存成功', 'success');
      loadXfqTimeLimitConfig();
    } catch (err) {
      console.error('保存失败:', err);
      alert(err?.message || err || '保存失败');
    }
  }

  // 更新支付优惠配置项
  function handlePaymentDiscountChange(key, value) {
    setPaymentDiscountConfig(prev => ({
      ...prev,
      [key]: value,
    }));
  }

  return (
    <Page title="系统管理">
      <Container>
        {/* <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <NavBack title="系统管理"></NavBack>
        </Stack> */}
        <Typography variant="h4" gutterBottom  mb={5}>
          系统管理
        </Typography>

        <Paper variant="outlined" sx={{ py: 1}}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={tab} onChange={handleTabChange}>
              {items.map((item) => (
                <Tab label={item.name} key={item.key} />
              ))}
            </Tabs>
          </Box>

          <TabPanel value={tab} index={0}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" gutterBottom>
                💳 商城支付优惠配置
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                优惠算法：0.01元 ~ min(订单金额×1%, 5元) 随机优惠
              </Typography>
            </Box>

            <Grid container spacing={3}>
              <Grid item md={12}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <span style={{ minWidth: '150px' }}>活动开关</span>
                  <Switch 
                    checked={paymentDiscountConfig.paymentDiscountEnabled} 
                    onChange={(e) => handlePaymentDiscountChange('paymentDiscountEnabled', e.target.checked)}
                  />
                  <Typography variant="body2" color="text.secondary">
                    {paymentDiscountConfig.paymentDiscountEnabled ? '已开启' : '已关闭'}
                  </Typography>
                </Stack>
              </Grid>

              <Grid item md={12}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <span style={{ minWidth: '150px' }}>最小优惠金额</span>
                  <TextField 
                    style={{ width: '200px' }} 
                    type="number" 
                    inputProps={{ step: "0.01", min: "0.01" }}
                    placeholder="0.01" 
                    value={paymentDiscountConfig.paymentDiscountMinAmount} 
                    size="small" 
                    onChange={(e) => handlePaymentDiscountChange('paymentDiscountMinAmount', e.target.value)}
                  />
                  <Typography variant="body2" color="text.secondary">
                    元
                  </Typography>
                </Stack>
              </Grid>

              <Grid item md={12}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <span style={{ minWidth: '150px' }}>最大优惠金额</span>
                  <TextField 
                    style={{ width: '200px' }} 
                    type="number" 
                    inputProps={{ step: "0.01", min: "0.01" }}
                    placeholder="5.00" 
                    value={paymentDiscountConfig.paymentDiscountMaxAmount} 
                    size="small" 
                    onChange={(e) => handlePaymentDiscountChange('paymentDiscountMaxAmount', e.target.value)}
                  />
                  <Typography variant="body2" color="text.secondary">
                    元（超过订单金额1%时按此金额封顶）
                  </Typography>
                </Stack>
              </Grid>

              <Grid item md={12}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <span style={{ minWidth: '150px' }}>优惠比例</span>
                  <TextField 
                    style={{ width: '200px' }} 
                    type="number" 
                    inputProps={{ step: "0.01", min: "0.001" }}
                    placeholder="0.01" 
                    value={paymentDiscountConfig.paymentDiscountRatio} 
                    size="small" 
                    onChange={(e) => handlePaymentDiscountChange('paymentDiscountRatio', e.target.value)}
                  />
                  <Typography variant="body2" color="text.secondary">
                    （0.01表示订单金额的1%）
                  </Typography>
                </Stack>
              </Grid>
            </Grid>

            <Box sx={{ mt: 4, p: 2, bgcolor: 'info.lighter', borderRadius: 1 }}>
              <Typography variant="body2" color="info.dark">
                <strong>📋 配置说明：</strong><br/>
                • 最小优惠金额：每笔订单最少可获得的优惠金额<br/>
                • 最大优惠金额：订单金额1%超过此值时，按此金额封顶<br/>
                • 优惠比例：订单金额的百分比，用于计算最大可优惠金额<br/>
                • 示例：订单100元，优惠比例1%，最大优惠=min(100×1%, 5)=1元，随机范围为0.01~1元
              </Typography>
            </Box>

            <Button 
              variant="contained" 
              onClick={handlePaymentDiscountSubmit}
              sx={{ mt: 3 }}
            >
              保存配置
            </Button>
          </TabPanel>

          <TabPanel value={tab} index={1}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" gutterBottom>
                🏪 商家权益金限额配置
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                控制商户单日可接收的权益金最大金额
              </Typography>
            </Box>

            <Grid container spacing={3}>
              <Grid item md={12}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <span style={{ minWidth: '150px' }}>限额开关</span>
                  <Switch 
                    checked={merchantXfqLimitConfig.offlineMerchantXfqLimitEnabled} 
                    onChange={(e) => handleMerchantXfqLimitChange('offlineMerchantXfqLimitEnabled', e.target.checked)}
                  />
                  <Typography variant="body2" color="text.secondary">
                    {merchantXfqLimitConfig.offlineMerchantXfqLimitEnabled ? '已开启' : '已关闭'}
                  </Typography>
                </Stack>
              </Grid>

              <Grid item md={12}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <span style={{ minWidth: '150px' }}>单日限额</span>
                  <TextField 
                    style={{ width: '200px' }} 
                    type="number" 
                    inputProps={{ step: "0.01", min: "0.01" }}
                    placeholder="10000.00" 
                    value={merchantXfqLimitConfig.offlineMerchantXfqDailyLimit} 
                    size="small" 
                    onChange={(e) => handleMerchantXfqLimitChange('offlineMerchantXfqDailyLimit', e.target.value)}
                  />
                  <Typography variant="body2" color="text.secondary">
                    元（商户单日可接收的权益金最大金额）
                  </Typography>
                </Stack>
              </Grid>
            </Grid>

            <Box sx={{ mt: 4, p: 2, bgcolor: 'info.lighter', borderRadius: 1 }}>
              <Typography variant="body2" color="info.dark">
                <strong>📋 配置说明：</strong><br/>
                • 开启后，商户单日接收的权益金总额不能超过设定的限额<br/>
                • 超过限额后，用户无法使用该商户进行权益金支付<br/>
                • 示例：设置限额10000元，商户当日已接收8000元，则最多还能接收2000元
              </Typography>
            </Box>

            <Button 
              variant="contained" 
              onClick={handleMerchantXfqLimitSubmit}
              sx={{ mt: 3 }}
            >
              保存配置
            </Button>
          </TabPanel>

          <TabPanel value={tab} index={2}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" gutterBottom>
                👤 用户权益金限额配置
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                控制用户单笔和单日的权益金支付限额
              </Typography>
            </Box>

            <Grid container spacing={3}>
              <Grid item md={12}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <span style={{ minWidth: '150px' }}>限额开关</span>
                  <Switch 
                    checked={userXfqLimitConfig.offlineUserXfqLimitEnabled} 
                    onChange={(e) => handleUserXfqLimitChange('offlineUserXfqLimitEnabled', e.target.checked)}
                  />
                  <Typography variant="body2" color="text.secondary">
                    {userXfqLimitConfig.offlineUserXfqLimitEnabled ? '已开启' : '已关闭'}
                  </Typography>
                </Stack>
              </Grid>

              <Grid item md={12}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <span style={{ minWidth: '150px' }}>单笔限额</span>
                  <TextField 
                    style={{ width: '200px' }} 
                    type="number" 
                    inputProps={{ step: "0.01", min: "0.01" }}
                    placeholder="1000.00" 
                    value={userXfqLimitConfig.offlineUserXfqSingleLimit} 
                    size="small" 
                    onChange={(e) => handleUserXfqLimitChange('offlineUserXfqSingleLimit', e.target.value)}
                  />
                  <Typography variant="body2" color="text.secondary">
                    元（用户单笔支付可使用的权益金最大金额）
                  </Typography>
                </Stack>
              </Grid>

              <Grid item md={12}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <span style={{ minWidth: '150px' }}>单日限额</span>
                  <TextField 
                    style={{ width: '200px' }} 
                    type="number" 
                    inputProps={{ step: "0.01", min: "0.01" }}
                    placeholder="5000.00" 
                    value={userXfqLimitConfig.offlineUserXfqDailyLimit} 
                    size="small" 
                    onChange={(e) => handleUserXfqLimitChange('offlineUserXfqDailyLimit', e.target.value)}
                  />
                  <Typography variant="body2" color="text.secondary">
                    元（用户单日可使用的权益金最大金额）
                  </Typography>
                </Stack>
              </Grid>
            </Grid>

            <Box sx={{ mt: 4, p: 2, bgcolor: 'info.lighter', borderRadius: 1 }}>
              <Typography variant="body2" color="info.dark">
                <strong>📋 配置说明：</strong><br/>
                • 单笔限额：用户单笔支付最多可使用的权益金金额<br/>
                • 单日限额：用户单日累计可使用的权益金最大金额<br/>
                • 超过限额后，用户需要减少权益金使用量或等待次日<br/>
                • 示例：单笔限额1000元，单日限额5000元，用户当日已使用3000元，则单笔最多还能支付1000元，当日最多还能支付2000元
              </Typography>
            </Box>

            <Button 
              variant="contained" 
              onClick={handleUserXfqLimitSubmit}
              sx={{ mt: 3 }}
            >
              保存配置
            </Button>
          </TabPanel>

          <TabPanel value={tab} index={3}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" gutterBottom>
                ⏰ 权益金使用限时配置
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                控制线下商户消费只能在指定时间段内使用权益金
              </Typography>
            </Box>

            <Grid container spacing={3}>
              <Grid item md={12}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <span style={{ minWidth: '150px' }}>限时开关</span>
                  <Switch 
                    checked={xfqTimeLimitConfig.offlineXfqTimeLimitEnabled} 
                    onChange={(e) => handleXfqTimeLimitChange('offlineXfqTimeLimitEnabled', e.target.checked)}
                  />
                  <Typography variant="body2" color="text.secondary">
                    {xfqTimeLimitConfig.offlineXfqTimeLimitEnabled ? '已开启' : '已关闭'}
                  </Typography>
                </Stack>
              </Grid>

              <Grid item md={12}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <span style={{ minWidth: '150px' }}>开始时间</span>
                  <TextField 
                    style={{ width: '200px' }} 
                    type="time"
                    inputProps={{ step: "60" }}
                    placeholder="09:00" 
                    value={xfqTimeLimitConfig.offlineXfqTimeLimitStart} 
                    size="small" 
                    onChange={(e) => handleXfqTimeLimitChange('offlineXfqTimeLimitStart', e.target.value)}
                  />
                  <Typography variant="body2" color="text.secondary">
                    （允许使用权益金的开始时间）
                  </Typography>
                </Stack>
              </Grid>

              <Grid item md={12}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <span style={{ minWidth: '150px' }}>结束时间</span>
                  <TextField 
                    style={{ width: '200px' }} 
                    type="time"
                    inputProps={{ step: "60" }}
                    placeholder="21:00" 
                    value={xfqTimeLimitConfig.offlineXfqTimeLimitEnd} 
                    size="small" 
                    onChange={(e) => handleXfqTimeLimitChange('offlineXfqTimeLimitEnd', e.target.value)}
                  />
                  <Typography variant="body2" color="text.secondary">
                    （允许使用权益金的结束时间）
                  </Typography>
                </Stack>
              </Grid>
            </Grid>

            <Box sx={{ mt: 4, p: 2, bgcolor: 'info.lighter', borderRadius: 1 }}>
              <Typography variant="body2" color="info.dark">
                <strong>📋 配置说明：</strong><br/>
                • 开启后，用户只能在规定时间段内使用权益金进行线下消费<br/>
                • 非时间段内，权益金支付选项将不可用<br/>
                • 示例：设置 09:00-21:00，则只有在这个时间段内才能使用权益金<br/>
                • 积分和现金支付不受此限制影响
              </Typography>
            </Box>

            <Button 
              variant="contained" 
              onClick={handleXfqTimeLimitSubmit}
              sx={{ mt: 3 }}
            >
              保存配置
            </Button>
          </TabPanel>
        </Paper>
      </Container>
    </Page>
  );
}
